import {MutableRefObject} from 'react';

export const scrollTo = (ref?: MutableRefObject<HTMLElement>) => {
  const top = !ref ? 0 : ref.current.offsetTop;
  window.scrollTo({top: 0, behavior: 'smooth'});
};
